<template>
    <div class="form-group">
        <div class="form-check">
            <input :id="name" class="form-check-input" type="checkbox" v-model="isChecked" @change="$emit('input', isChecked)" />
            <label :for="name" class="form-check-label">
                {{ label }}
            </label>
        </div>

        <div class="invalid-feedback d-block" v-if="error">
            {{ error }}
        </div>

    </div>
</template>

<script>
export default {
    name: "SingleCheckboxInput",
    props: {
        name: { type: String, required: true },
        label: { type: String, default: '', required: false },
        error: { type: String, default: '', required: false },
        value: { type: Boolean, default: false}
    },
    data() {
        return  {
            isChecked: this.value || false
        }
    }
}
</script>